exports['default'] = {
	NewListRec: require('./new_list_rec').default,
    SlideRec: require('./slide_rec').default,
    ListRec: require('./list_rec').default,
    RankRec: require('./rank_rec').default,
    SlideWorks: require('./slideWorks/SlideWorks.js').default,
    RecA: require('./rec_a.js').default,
    RecB: require('./rec_b.js').default,
    RecC: require('./rec_c.js').default,
}
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./src/component/rec/index.js